import React from 'react';
import { useTranslation } from 'react-i18next';

import { InputHandler } from '../../../../../viewer/input-handler';
import { SubscriptionTopic } from '../../../../../viewer/messaging/pubsub';
import { useNonce } from '../../../../hooks/use-nonce';
import { useSubscribe } from '../../../../hooks/use-subscribe';
import { SkyviewContext } from '../../../skyview/skyview-state';
import { ToolIcon } from '../tool-icon';

const WmsToolIcon = () => {
  const { t } = useTranslation();
  const { skyview } = React.useContext(SkyviewContext);

  const [, refresh] = useNonce();

  // Subscribe to camera type changes to reevaluate the tool's availability.
  useSubscribe(SubscriptionTopic.OnCameraChanged, (message) => {
    refresh();
  });

  return (
    <ToolIcon
      active={InputHandler.instance.isWmsToolActive()}
      callback={() => {
        InputHandler.instance.toggleTool('wms', 'select');
      }}
      disabled={!skyview.isWmsMapAvailable()}
      icon={['fal', 'map']}
      tooltip={{
        title: t('wms.tooltip.title', { ns: 'skyviewToolbar' }),
        text: t('wms.tooltip.text', { ns: 'skyviewToolbar' }),
      }}
    />
  );
};

export { WmsToolIcon };
